module.exports = __webpack_public_path__ + "img/packages/bot_row_tablet.f53fc2.png";